import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../../../../components/ui/card';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { FinalBalanceProps } from './FinalBalance.types';
import { CheckCircle, XCircle } from 'lucide-react';

export const FinalBalance: React.FC<FinalBalanceProps> = ({ balance, onObservationsChange }) => {
  const formatCurrency = (amount: number | null | undefined): string => {
    const safeAmount = amount || 0;
    return `S/ ${safeAmount.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const formatDifference = (difference: number | null | undefined): string => {
    const safeDifference = difference || 0;
    const sign = safeDifference > 0 ? '+' : '';
    return `${sign}${safeDifference.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const getDifferenceColor = (difference: number): string => {
    if (difference > 0) return 'text-green-600';
    if (difference < 0) return 'text-red-600';
    return 'text-gray-600';
  };

  const getStatusIcon = (canClose: boolean) => {
    return canClose ? (
      <CheckCircle className="w-5 h-5 text-green-600" />
    ) : (
      <XCircle className="w-5 h-5 text-red-600" />
    );
  };

  const getStatusText = (canClose: boolean): string => {
    return canClose ? '✓ Listo para cerrar' : '✗ Diferencia muy alta';
  };

  const getStatusColor = (canClose: boolean): string => {
    return canClose ? 'text-green-600' : 'text-red-600';
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cuadre Final</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Efectivo esperado */}
          <div className="flex justify-between">
            <span>Efectivo esperado:</span>
            <span className="font-semibold">{formatCurrency(balance.expectedCash)}</span>
          </div>

          {/* Efectivo contado */}
          <div className="flex justify-between">
            <span>Efectivo contado:</span>
            <span className="font-semibold">{formatCurrency(balance.countedCash)}</span>
          </div>

          {/* Diferencia */}
          <div className="flex justify-between">
            <span>Diferencia:</span>
            <span className={`font-bold ${getDifferenceColor(balance.difference)}`}>
              S/ {formatDifference(balance.difference)}
            </span>
          </div>

          {/* Estado */}
          <div className="flex justify-between items-center">
            <span>Estado:</span>
            <div className="flex items-center gap-2">
              {getStatusIcon(balance.canClose)}
              <span className={`font-semibold ${getStatusColor(balance.canClose)}`}>
                {getStatusText(balance.canClose)}
              </span>
            </div>
          </div>

        </div>
      </CardContent>
    </Card>
  );
};